export default "__VITE_ASSET__BvwYPa80__"